import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { RegistrationDetailResponse } from '../model/response/registration-detail.response';
import { RegistrationListResponse } from '../model/response/registration-list.response';
import { DefaultResponseInterface } from '../model/response/default-response.interface';

@Injectable()
export class AdminRegistrationContractsApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchRegistrations(filter, page, limit) {
    return this.http.get<DefaultResponseInterface>(
      this.prepareListRequest(
        this.baseUrl + '/api/cf/administration/registration-contracts',
        page,
        limit,
        [{id: 'DESC'}],
        filter
      ),
      {headers: this.getAuthHeaders()}
    );
  }

  public fetchDetail(id) {
    return this.http.get<DefaultResponseInterface>(
      this.baseUrl + '/api/cf/administration/registration-contracts/' + id,
      {headers: this.getAuthHeaders()}
    );
  }
}
